<template>
  <div>
    <h1>{{ t('messages.messages') }}</h1>
    <stop-messages/>
  </div>
</template>

<script>
import StopMessages from './StopMessages.vue'
import { useI18n } from 'vue-i18n';
export default {
  name: "MessagePage",
  setup() {
    const { t } = useI18n();
    return { t };
  },
  components: { StopMessages },

}
</script>

<style>

</style>